module.exports = __webpack_public_path__ + "static/media/1.0f01914b.jpg";